module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAX0lEQVQ4jWOgBWAEmTlz5sz/1DI7PT2dkQXGKe/4xIihAg10VvBhiKEBsONYsAniAIxEyIMBE4YUFcCooUPEUPQkRSitEkzLKIZCE/ZoOh01lEJA23RKIA0OMGBgYAAAss0ORBPb7ysAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/icon/icon_view1.png
// module id = TNZ9
// module chunks = 3